import { Button, Grid, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainHeader = styled("div")(({ theme }) => ({
  height: "72px",
  width: "100%",
  background: theme.palette.primary.main,
  borderRadius: `${theme.custom.radius[0]} ${theme.custom.radius[0]} 0px 0px`,
  zIndex: -1,
  position: "absolute",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "0px",
    height: "161px",
  },
}));

export const TitleContainer = styled(Grid)(({ theme }) => ({
  color: theme.custom.palette.light,
  backgroundColor: theme.palette.primary.main,
  padding: `0 ${theme.spacing(3)}`,
  height: "72px",
}));

export const ContentContainer = styled(Grid)(({ theme }) => ({
  background: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[50],
}));

export const Title = styled("h2")({
  fontSize: "1.125rem",
  lineHeight: "1.375rem",
  margin: "0px",
  fontWeight: 500,
});

export const PaperContainer = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: theme.spacing(3),
  boxShadow: theme.custom.shadows[0],
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "white",
}));

export const PaperButton = styled(Button)(({ theme }) => ({
  width: "50%",
  height: "64px",
  borderRadius: 0,
  background: theme.palette.mode === "dark" ? theme.palette.grey[800] : "white",
  border: `1px solid ${theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[50]}`,
  borderLeft: "none",
  color: theme.palette.text.link,
  fontWeight: 600,
  ["&:last-child"]: {
    borderRight: "none",
  },
  ["&:hover"]: {
    background: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[100],
    borderColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[100],
    color: theme.palette.mode === "dark" ? null : theme.palette.primary.main,
  },
}));

export const SectionTitle = styled("h3")(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
  margin: "0px",
  padding: "",
}));

interface SectionTextProps {
  [key: string]: string | string[];
}
export const SectionText = styled("p")<SectionTextProps>(({ theme, topMargin }) => ({
  fontSize: "0.875rem",
  textAlign: "left",
  color: theme.palette.text.primary,
  marginTop: topMargin && theme.spacing(2),
  marginBottom: "0px",
}));

export const HoursText = styled("div")(({ theme }) => ({
  fontSize: "0.75rem",
  textAlign: "left",
  color: theme.palette.text.primary,

  "& > span": {
    display: "block",
  },
}));
